import React from 'react';
import InstructionsDialog from '../../../InstructionsDialog';
import Cookies from 'js-cookie';
import { DOMAIN } from '../../shared/utils';
import { PuzzleNames } from '../../../../utils/types';
import { Pathword5x5Store } from '../Pathword5x5Store';

const closeInstructions = () => {
  Pathword5x5Store.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Pathword5x5}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = Pathword5x5Store.useState(s => s.instructionsAreOpen);

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions}>
      <h1 className="instructionsTitle">How to Play the Pathword 5x5</h1>
      <div className="instructionsBody triwordInstructions">
          <p>This puzzle is simply a bigger version of the normal Pathword. The rules are the same. Make sure you've solved that one first before attempting this.</p>
          <p>The 5x5 is meant for those days when the normal Pathword isn't enough and you're left wanting more.</p>

          <p>But we'll warn you: the 5x5 is <span className="italicText">much</span> harder.</p>

          <p>As before, start at the star. There is only one solution. Good luck.</p>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;